export interface ISelectMapObject {
  type: string,
  data: {
    id: string
  }
}
export interface IMapSettingState{
  typeLayers: string[],
  
  selectMapObject: ISelectMapObject,

  zoom: number,
  position: [number, number],
  errorsMapSetting: string,
  isLoadingMapSetting: boolean,
}

export enum MapSettingActionEnum {
  DELETE_TO_VISIBLE_LAYERS= "DELETE_TO_VISIBLE_LAYERS",
  PUSH_TO_VISIBLE_LAYERS = "PUSH_TO_VISIBLE_LAYERS",
  SET_LAYER_SETTINGS = "SET_LAYER_SETTINGS",
  IS_LOADING_MAP_SETTING = "IS_LOADING_MAP_SETTING",
  GET_ERROR_MAP_SETTING = "GET_ERROR_MAP_SETTING",
  SELECT_MAP_OBJECT = "SELECT_MAP_OBJECT"
}

interface ISetLayerSettingsAction {
  type: MapSettingActionEnum.SET_LAYER_SETTINGS;
  payload: any
}

interface IPushToVisibleLayersAction {
  type: MapSettingActionEnum.PUSH_TO_VISIBLE_LAYERS;
  payload: any
}

interface IDeleteToVisibleLayersAction {
  type: MapSettingActionEnum.DELETE_TO_VISIBLE_LAYERS;
  payload: any
}

interface IIsLoadingMapSettingAction {
  type: MapSettingActionEnum.IS_LOADING_MAP_SETTING;
  payload: any
}

interface IGetErrorMapSettingAction {
  type: MapSettingActionEnum.GET_ERROR_MAP_SETTING;
  payload: any
}


interface ISelectMapUnitAction {
  type: MapSettingActionEnum.SELECT_MAP_OBJECT;
  payload: any
}


export type IMapSettingAction =
  IPushToVisibleLayersAction |
  IDeleteToVisibleLayersAction |
  IIsLoadingMapSettingAction |
  IGetErrorMapSettingAction |
  ISelectMapUnitAction | ISetLayerSettingsAction